type TaskDefinition = { name?: unknown; description?: unknown }

/** Identifies the instructions an AI plan was generated for. */
export function taskDefinitionSignature(def: TaskDefinition): string {
  return String(def.description || '').trim()
}

/**
 * Replan only when instructions change — a rename must not block PATCH on an LLM call.
 * Skip the server replan when the panel just regenerated a plan for these instructions.
 */
export function shouldReplanScheduledTask(
  next: TaskDefinition,
  current: TaskDefinition,
  options: { aiPlanSignature?: string | null } = {},
): boolean {
  const nextDescription = taskDefinitionSignature(next)
  if (nextDescription === taskDefinitionSignature(current)) return false
  return options.aiPlanSignature !== nextDescription
}
